import { get, writable } from 'svelte/store';

import type { ConversationPartner, Partner } from '@api/types';

import type { PartnerStoreState, Store } from './types';

function createStore(): Store {
    const store = writable<PartnerStoreState | null>(null);
    const { subscribe, update, set } = store;

    const onPartnerUpdated = (partner: PartnerStoreState): PartnerStoreState => {
        const pu: PartnerStoreState = {
            ...partner,
        };
        return pu;
    };

    const updateStore = (data: Partial<PartnerStoreState> | null) => {
        update((state) => {
            const id = data?.id ?? state?.id;
            const intId = data?.intId ?? state?.intId;
            const displayName = data?.displayName ?? state?.displayName;
            return data && id
                ? onPartnerUpdated({
                    ...(state ?? {}),
                    ...data,
                    id,
                    intId,
                    displayName,
                } as PartnerStoreState)
                : null;
        });
    };

    return {
        update,
        set,
        subscribe,
        get: () => {
            return get(store);
        },
        onConversationStarted: (partner: ConversationPartner) => {
            updateStore({
                displayName: partner.displayName,
                intId: partner.intId,
                id: partner.id,
                canCall: partner.canCall,
                isBlockedBy: partner.isBlockedBy,
                isBlocked: partner.isBlocked,
                inFavoriteList: partner.inFavoriteList,
            });
        },
        onRoomStarted: (partner: Partner) => {
            updateStore({
                ...onPartnerUpdated({ ...partner, isBlocked: false, isBlockedBy: false }),
                id: partner.id,
                displayName: partner.displayName,
                inFavoriteList: partner.inFavoriteList,
                intId: partner.intId,
                canCall: partner.canCall,
            });
        },
        changeFavoriteList: (val: boolean) => {
            updateStore({ inFavoriteList: val });
        },
        changeIsBlocked: (id: string, val: boolean) => {
            const state = get(store);

            if (id !== state?.id) {
                return;
            }

            updateStore({ isBlocked: val, inFavoriteList: val ? false : state?.inFavoriteList });
        },
        changeIsBlockedBy: (id: string, val: boolean) => {
            const state = get(store);

            if (id !== state?.id) {
                return;
            }

            updateStore({ isBlockedBy: val });
        },
    };
}

export const partnerStore = createStore();
